import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: null
  },
  mutations: {
    load: (state, data) => { state.list = data }
  },
  actions: {
    init (state) { socket.get('SportFootballActionOrigin', 'Sport/Football/Action/Origin/load') }
  },
  getters: {
    list: state => JSON.parse(JSON.stringify(state.list)),
    get: (getters) => (id) => { return getters.list.find(item => { return item.id === id }) }
  }
}
